import { render, staticRenderFns } from "./SidebarLoader.vue?vue&type=template&id=26ff265e"
import script from "./SidebarLoader.vue?vue&type=script&lang=js"
export * from "./SidebarLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports